import styles from "./MarketPlaceDetail.module.css";
import { MdDeleteForever } from "react-icons/md";

/**
 * Feature-comparison editor (headings + row titles + per-plan values), scoped
 * to the selected type. Extracted verbatim from the T1/T2/T3 grid so the
 * feature handlers + state shape stay identical — this is presentation reuse
 * only. All mutations flow through the handlers passed in from the template.
 */
export default function FeaturesEditor({
  features,
  plans,
  selected,
  selectInterval,
  isOwner,
  featureErrors = {},
  onHeadingChange,
  onTitleChange,
  onValueChange,
  onAddRow,
  onAddHeading,
  onRemoveHeading,
  onRemoveRow,
  onDuplicate,
}) {
  const disabled = !isOwner;
  return (
    <div>
      <div className={styles.heading}>Features</div>
      <div className={styles.featuresGrid}>
        {features.map((feature, i) => (
          <div key={i} className={styles.featureCard}>
            <div style={{ width: "100%" }}>
              <div className={styles.featureHeader}>
                <input
                  type="text"
                  value={feature.name}
                  className={`${styles.inputHeading}
                  ${
                    featureErrors?.[feature.key]?.heading
                      ? styles.input_error
                      : ""
                  }`}
                  placeholder="feature Heading"
                  readOnly={disabled}
                  onChange={(e) => onHeadingChange(e, feature.key)}
                />
                <button
                  className={styles.deleteButton}
                  disabled={disabled}
                  onClick={() => onRemoveHeading(feature.key)}
                >
                  <MdDeleteForever />
                </button>
                <button
                  className={styles.duplicateBtn}
                  disabled={disabled}
                  onClick={() => onDuplicate(feature.key)}
                >
                  Duplicate
                </button>
              </div>
            </div>
            <div className={styles.rows}>
              <div className={styles.rowContainer}>
                {feature.data.map((title, j) => (
                  <div key={j} className={styles.row}>
                    <div>
                      <input
                        type="text"
                        name="data"
                        value={title}
                        className={`${styles.inputtitle} ${
                          featureErrors?.[feature.key]?.titles?.[j]
                            ? styles.input_error
                            : ""
                        }`}
                        placeholder="feature title"
                        onChange={(e) => onTitleChange(e, feature.key, j)}
                        readOnly={disabled}
                      />
                    </div>
                    {plans.length > 0 &&
                      plans
                        .filter(
                          (item) =>
                            item.typeId === selected &&
                            item.interval === selectInterval,
                        )
                        .map((p) => {
                          const planFeature = p.features.find(
                            (pf) => pf.key === feature.key,
                          );
                          return (
                            <div key={p.id}>
                              <input
                                type="text"
                                value={planFeature?.data?.[j] || ""}
                                placeholder="value"
                                className={`${styles.input} ${
                                  featureErrors?.[feature.key]?.values?.[j]
                                    ? styles.input_error
                                    : ""
                                }`}
                                onChange={(e) =>
                                  onValueChange(e, feature.key, j, p.id)
                                }
                                readOnly={disabled}
                              />
                            </div>
                          );
                        })}
                    <div
                      className={`${styles.deleteButton} ${disabled ? styles.disabled : ""}`}
                      onClick={() => onRemoveRow(feature.key, j)}
                      style={{ textAlign: "center" }}
                    >
                      <MdDeleteForever />
                    </div>
                  </div>
                ))}
              </div>
              <button
                className={`${styles.btn}`}
                disabled={disabled}
                onClick={() => onAddRow(feature.key)}
              >
                Add +
              </button>
            </div>
          </div>
        ))}
        <button
          disabled={disabled}
          className={`${styles.btnPrimary}`}
          onClick={onAddHeading}
        >
          New Features
        </button>
      </div>
    </div>
  );
}
